import { Box, IconButton } from "@mui/material";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import ThumbDownAltIcon from "@mui/icons-material/ThumbDownAlt";
import ThumbDownOffAltIcon from "@mui/icons-material/ThumbDownOffAlt";
import { DotLegalDialog, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import { useAiChatStyles } from "../AiChat.styles";
import { useMessageBubbleFeedback } from "./MessageBubbleFeedback.hooks";

interface MessageBubbleFeedbackProps {
    messageId: string;
    initialIsPositive?: boolean | null;
    styles: ReturnType<typeof useAiChatStyles>;
}

function MessageBubbleFeedback({ messageId, initialIsPositive, styles }: MessageBubbleFeedbackProps) {
    const { translateString } = useTranslation();
    const { isPositive, pendingIsPositive, comment, setComment, onThumbClick, submitFeedback, closeDialog } = useMessageBubbleFeedback(
        messageId,
        initialIsPositive
    );

    return (
        <>
            <Box sx={styles.feedbackRow}>
                <IconButton
                    size="small"
                    onClick={() => onThumbClick(true)}
                    sx={isPositive === true ? styles.feedbackIconButtonSelected : styles.feedbackIconButton}
                >
                    {isPositive === true ? <ThumbUpAltIcon sx={{ fontSize: 16 }} /> : <ThumbUpOffAltIcon sx={{ fontSize: 16 }} />}
                </IconButton>
                <IconButton
                    size="small"
                    onClick={() => onThumbClick(false)}
                    sx={isPositive === false ? styles.feedbackIconButtonSelected : styles.feedbackIconButton}
                >
                    {isPositive === false ? <ThumbDownAltIcon sx={{ fontSize: 16 }} /> : <ThumbDownOffAltIcon sx={{ fontSize: 16 }} />}
                </IconButton>
            </Box>
            {pendingIsPositive !== null && (
                <DotLegalDialog
                    open
                    size="sm"
                    header={pendingIsPositive ? translateString("aiChatFeedbackGood") : translateString("aiChatFeedbackBad")}
                    buttonOkText={translateString("submit")}
                    onOkClick={submitFeedback}
                    onDialogClose={closeDialog}
                >
                    <DotLegalTextField
                        label=""
                        value={comment}
                        onChange={setComment}
                        placeholder={translateString("aiChatFeedbackCommentPlaceholder")}
                        multiline
                        rows={4}
                        maxLength={2000}
                        debounce={false}
                        noMargin
                        autoFocus
                    />
                </DotLegalDialog>
            )}
        </>
    );
}

export default MessageBubbleFeedback;
